import React from 'react';

const AddressMap = ({className}) => {
    return (
        <div className={className} style={{position: "relative"}}>
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5867.046322760197!2d23.537163523925393!3d42.67145920272819!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40aa62cd035f1277%3A0x2c352dd1c64ba9!2z0JPQvtC70YQg0LrQu9GD0LEg0Lgg0YHQv9CwIOKAntCh0LIuINCh0L7RhNC40Y_igJw!5e0!3m2!1sbg!2sbg!4v1735123695877!5m2!1sbg!2sbg?layout=embedded"
                width="100%"
                height="100%"
                style={{border: 0}}
                loading="lazy"
            />
        </div>
    );
};

export default AddressMap;